import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const QuickStartContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S8};
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
`
